import { ControllerBase } from "controllerBase";
import global from 'globalMU'
import { EditarLoteProdutoController } from "./editarLoteProdutoController";


declare var window:any

const LotesProdutoController = ControllerBase.extend({
    name: "LotesProdutoController",

    framework: "knockout",

    ajax: function() {

        return {
            url: "/Orcamento/_LotesProduto",
            type: "post",
            cache: false,
            data: {
                identificadorOrcamento: this.orcamento.get("IdentificadorOrcamento"),
                codigoObjetoItem: this.codigoObjetoItem
            }
        };
    },

    antesBinding: function () {

        this.appendToModel({
            name: "QuantidadeFaltante",
            value: this.model.QuantidadePedida() - this.model.QuantidadeReservada()
        });

        this.model.QuantidadeReservada.subscribe($.proxy(function(newValue) {
                this.model.QuantidadeFaltante(this.model.QuantidadePedida() - this.model.QuantidadeReservada());

                if (this.renderizarCallback) {
                    this.renderizarCallback();
                }
            },
            this));
    },

    editar: function(model) {
        if (model && model.PermiteVendaLote && !model.PermiteVendaLote()) {
            global.showErrorMessage("Lote não pode ser utilizado.");
            return;
        }
        this.editarLoteProdutoController = this.showView({
            region: {
                name: "editarLoteProdutoRegion",
                selector: "#editar-lote-produto-region"
            },
            model: {
                Produto: this.toJS(this.model),
                Lote: this.toJS(model)
            },
            controller: {
                type: EditarLoteProdutoController,
                args: {
                    orcamento: this.orcamento,
                    codigoObjetoItemOrcamento: this.model.CodigoObjetoItemOrcamento(),
                    produto: this.model,
                    lote: model,
                    finalizarCallback: $.proxy(this.finalizarEdicao, this),
                    readOnly: this.orcamento.get("SomenteLeitura") || this.orcamento.get("CodigoDAV") != "",
                }
            }
        });

    },

    finalizarEdicao: function() {
        this.editarLoteProdutoController.hide();
        this.show();
    }


})

window.LotesProdutoController = LotesProdutoController

export {
    LotesProdutoController
}